import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b990dfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex cleopatra flex-col w-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container flex gap-2 justify-between max-w-5xl mx-auto overflow-x-auto p-5 pb-3 xl:flex-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, "Profile Settings")
  ])
], -1))
const _hoisted_3 = { class: "container flex flex-col gap-2 max-w-5xl mx-auto overflow-x-auto p-5" }
const _hoisted_4 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_5 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_6 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "First Name")
], -1))
const _hoisted_8 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_9 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Last Name")
], -1))
const _hoisted_11 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_12 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Email")
], -1))
const _hoisted_14 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_15 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Phone")
], -1))
const _hoisted_17 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_18 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Password")
], -1))
const _hoisted_20 = { class: "flex flex-col select-none items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "email",
  class: "form-field select-none w-full sm:w-72",
  value: "********"
}, null, -1))
const _hoisted_22 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "Default Adress"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1))
const _hoisted_24 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Address")
], -1))
const _hoisted_26 = { class: "flex flex-col gap-2 items-end w-full sm:w-9/12" }
const _hoisted_27 = { class: "flex gap-2 w-full sm:w-96" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "email",
  class: "form-field w-full sm:w-96",
  placeholder: "Additional Description"
}, null, -1))
const _hoisted_29 = { class: "flex gap-2 w-full sm:w-96" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { class: "w-96" }, "Prishtina", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { class: "w-96" }, "10000", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { class: "w-96" }, "Kosovëo", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Coordinates")
], -1))
const _hoisted_38 = { class: "flex gap-2 justify-center w-full sm:justify-end sm:w-6/12" }
const _hoisted_39 = { class: "flex flex-col items-center sm:items-end" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, "Latitude", -1))
const _hoisted_41 = { class: "flex flex-col items-center sm:items-end" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, "Longitude", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://media.wired.com/photos/59269cd37034dc5f91bec0f1/191:100/w_1280,c_limit/GoogleMapTA.jpg" })
], -1))
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"box-details flex flex-col gap-4 p-5\" data-v-7b990dfe><div class=\"flex items-center\" data-v-7b990dfe><div class=\"bg-gray-100 h-[1px] mr-3 w-full\" data-v-7b990dfe></div><p class=\"min-w-max text uppercase\" data-v-7b990dfe>ASSIGNEMENTS</p><div class=\"bg-gray-100 h-[1px] ml-3 w-full\" data-v-7b990dfe></div></div><div class=\"flex gap-2 items-center justify-between\" data-v-7b990dfe><select class=\"form-field w-1/2\" data-v-7b990dfe><option class=\"w-96\" data-v-7b990dfe>Assignement</option><option value=\"US\" data-v-7b990dfe>United States</option><option value=\"CA\" data-v-7b990dfe>Canada</option><option value=\"FR\" data-v-7b990dfe>France</option><option value=\"DE\" data-v-7b990dfe>Germany</option></select><select class=\"form-field w-1/2\" data-v-7b990dfe><option class=\"w-96\" data-v-7b990dfe>Role</option><option value=\"US\" data-v-7b990dfe>United States</option><option value=\"CA\" data-v-7b990dfe>Canada</option><option value=\"FR\" data-v-7b990dfe>France</option><option value=\"DE\" data-v-7b990dfe>Germany</option></select><div class=\"flex flex-col\" data-v-7b990dfe><svg width=\"15\" height=\"16\" viewBox=\"0 0 15 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-7b990dfe><path d=\"M12.7869 6.08365C12.7869 6.08365 12.376 11.1806 12.1376 13.3277C12.0241 14.3531 11.3907 14.954 10.3531 14.9729C8.37863 15.0085 6.40189 15.0108 4.42817 14.9691C3.42996 14.9487 2.80712 14.3403 2.69587 13.333C2.45597 11.167 2.0473 6.08365 2.0473 6.08365\" stroke=\"#ED5151\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7b990dfe></path><path d=\"M13.8337 3.64039H1\" stroke=\"#ED5151\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7b990dfe></path><path d=\"M11.3609 3.64045C10.7669 3.64045 10.2553 3.22043 10.1387 2.63846L9.95483 1.7182C9.84131 1.29364 9.45686 1 9.01868 1H5.81517C5.37699 1 4.99254 1.29364 4.87902 1.7182L4.69512 2.63846C4.57857 3.22043 4.06698 3.64045 3.4729 3.64045\" stroke=\"#ED5151\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7b990dfe></path></svg></div></div><div class=\"flex gap-2 items-center justify-center\" data-v-7b990dfe><span class=\"text-title-link\" data-v-7b990dfe>+ Add Assignment</span></div></div>", 1)
const _hoisted_45 = { class: "flex flex-col gap-4 p-5" }
const _hoisted_46 = { class: "flex justify-end" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Update", -1))
const _hoisted_48 = [
  _hoisted_47
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailModal = _resolveComponent("EmailModal")!
  const _component_PhoneModal = _resolveComponent("PhoneModal")!
  const _component_PasswordModal = _resolveComponent("PasswordModal")!
  const _component_PhoneOtp = _resolveComponent("PhoneOtp")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-field w-full sm:w-72",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.result.firstName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.result.firstName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-field w-full sm:w-72",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.result.lastName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.result.lastName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-field w-full sm:w-72",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.result.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.result.email]
                ]),
                _createElementVNode("span", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showEmailModal = !_ctx.showEmailModal)),
                  class: "pr-3 text-small-link"
                }, "Change Email")
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-field w-full sm:w-72",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.result.phone) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.result.phone]
                ]),
                _createElementVNode("span", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPhoneModal = !_ctx.showPhoneModal)),
                  class: "pr-3 text-small-link"
                }, "Change Phone Number")
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPassModal = !_ctx.showPassModal)),
                  class: "pr-3 text-small-link"
                }, "Change Password")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.result.email) = $event)),
                    type: "text",
                    class: "form-field w-8/12",
                    placeholder: "Street"
                  }, null, 512), [
                    [_vModelText, _ctx.result.email]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.result.email) = $event)),
                    type: "text",
                    class: "form-field w-4/12",
                    placeholder: "No"
                  }, null, 512), [
                    [_vModelText, _ctx.result.email]
                  ])
                ]),
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.result.email) = $event)),
                    class: "form-field w-4/12"
                  }, _hoisted_31, 512), [
                    [_vModelSelect, _ctx.result.email]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.result.Email) = $event)),
                    class: "form-field w-4/12"
                  }, _hoisted_33, 512), [
                    [_vModelSelect, _ctx.result.Email]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.result.Email) = $event)),
                    class: "form-field w-4/12"
                  }, _hoisted_35, 512), [
                    [_vModelSelect, _ctx.result.Email]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.result.Email) = $event)),
                    type: "text",
                    class: "form-field w-full md:w-36",
                    placeholder: "42.422211"
                  }, null, 512), [
                    [_vModelText, _ctx.result.Email]
                  ]),
                  _hoisted_40
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.result.Email) = $event)),
                    type: "text",
                    class: "form-field w-full md:w-36",
                    placeholder: "21.122211"
                  }, null, 512), [
                    [_vModelText, _ctx.result.Email]
                  ]),
                  _hoisted_42
                ])
              ])
            ]),
            _hoisted_43
          ]),
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", {
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args))),
                class: "button"
              }, _hoisted_48)
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_EmailModal, { onClose: _ctx.closeModal }, null, 8, ["onClose"]), [
      [_vShow, _ctx.showEmailModal]
    ]),
    _withDirectives(_createVNode(_component_PhoneModal, { onPhoneclose: _ctx.close }, null, 8, ["onPhoneclose"]), [
      [_vShow, _ctx.showPhoneModal]
    ]),
    _withDirectives(_createVNode(_component_PasswordModal, {
      onPassclose: _ctx.closeModal,
      onSuccess: _ctx.update
    }, null, 8, ["onPassclose", "onSuccess"]), [
      [_vShow, _ctx.showPassModal]
    ]),
    _withDirectives(_createVNode(_component_PhoneOtp, null, null, 512), [
      [_vShow, _ctx.OptSrv.Mode]
    ])
  ], 64))
}